import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography, Button } from '@mui/material';

const Home = () => (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Welcome to Around demo
      </Typography>
      <Button variant="contained" component={Link} to="/checksum">
        view the demo
      </Button>
    </Container>
);

export default Home